import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { isString, logErrorAndRunFail } from '../../utils';

export function setStorageSync(key: String, data: any) {
  if (!isString(key)) {
    return logErrorAndRunFail(
      APINames.Native.SET_STORAGE_SYNC,
      {},
      `parameter error:key should be string instead of ${typeof key}.`
    );
  }
  return MacleJSBridge.invokeSync(APINames.Native.SET_STORAGE_SYNC, {
    key,
    data
  });
}
